import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { useEffect } from "react";
const ReadonlyPlugin = ({ readonly }) => {
    const [editor] = useLexicalComposerContext();
    useEffect(() => {
        editor.setEditable(!readonly);
    }, [editor, readonly]);
    return null;
};
export default ReadonlyPlugin;
//# sourceMappingURL=readonly-plugin.js.map